@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.formOverlay::after {
  content: ' ';
  background:  hevo-toolkit-variables.$surface-bg-60;
  position: absolute;
  height: 100%;
  width: 100%;
  padding:  hevo-toolkit-variables.$spacer * 0.65 0px;
  top: 0;
  left: 0;
  z-index: 4;
}
